module.exports = __webpack_public_path__ + "img/ico-plan-business.18f31e9d.svg";